import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "c_p_relative" }

import NavHeader from '@/layout/AppHeader/index.vue'
import NavDrawer from '@/layout/AppNavDrawer/index.vue'
import { useRoute } from 'vue-router'
import shared from '@/micro/shared'
import { computed, reactive } from 'vue'
import locale from 'element-plus/es/locale/lang/zh-cn'


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const messageConfig = reactive({
  max: 3,
})

const route = useRoute()
const appName = computed(() => shared.getAppName())

return (_ctx: any,_cache: any) => {
  const _component_el_header = _resolveComponent("el-header")!
  const _component_el_container = _resolveComponent("el-container")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_el_config_provider = _resolveComponent("el-config-provider")!

  return (_openBlock(), _createBlock(_component_el_config_provider, {
    locale: _unref(locale),
    message: messageConfig
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_unref(route).name !== 'login')
          ? (_openBlock(), _createBlock(_component_el_container, { key: 0 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_header, null, {
                  default: _withCtx(() => [
                    _createVNode(NavHeader)
                  ]),
                  _: 1
                }),
                _withDirectives(_createElementVNode("div", null, [
                  _createVNode(NavDrawer)
                ], 512), [
                  [_vShow, appName.value !== 'admin']
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_router_view, {
          class: _normalizeClass({ main_content: _unref(route).name !== 'login' })
        }, null, 8, ["class"]),
        _cache[0] || (_cache[0] = _createElementVNode("div", { id: "subApp" }, null, -1))
      ])
    ]),
    _: 1
  }, 8, ["locale", "message"]))
}
}

})